import React from 'react';
import { motion } from 'framer-motion';
const team = [{
  name: 'Thessaly Voss',
  role: 'Growth Strategist',
  bio: 'Former Twitch partner manager. Scaled 200+ channels past 10K concurrent.',
  initials: 'TV'
}, {
  name: 'Caspian Dray',
  role: 'Monetization Architect',
  bio: 'Built revenue systems generating €5M+ across gaming and IRL verticals.',
  initials: 'CD'
}, {
  name: 'Isolde Kael',
  role: 'Brand Partnership Lead',
  bio: 'Negotiated 400+ sponsorship deals. Ex-agency director at a top esports firm.',
  initials: 'IK'
}, {
  name: 'Fenwick Tarn',
  role: 'Analytics Director',
  bio: 'Data scientist turned streaming analyst. Designed predictive audience models for top 100 creators.',
  initials: 'FT'
}];
export function Team() {
  return <section id="team" className="py-24 relative z-10 bg-studio-950 border-t border-white/5" data-id="element-162">
      <div className="max-w-7xl mx-auto px-6" data-id="element-163">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-164">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-165">
            The Control Room
          </h2>
          <p className="text-gray-400 font-mono text-sm uppercase tracking-widest" data-id="element-166">
            Core Operators
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-167">
          {team.map((member, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="glass-panel p-6 rounded-xl group hover:border-stream-500/50 transition-all text-center" data-id="element-168">
              <div className="w-20 h-20 mx-auto rounded-full bg-studio-800 border-2 border-white/10 group-hover:border-stream-500 flex items-center justify-center mb-6 transition-colors relative overflow-hidden" data-id="element-169">
                <div className="absolute inset-0 bg-stream-500/10 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-170" />
                <span className="font-mono text-xl font-bold text-gray-300 group-hover:text-white relative z-10" data-id="element-171">
                  {member.initials}
                </span>
              </div>

              <h3 className="text-lg font-bold text-white mb-1" data-id="element-172">
                {member.name}
              </h3>
              <p className="text-stream-400 text-sm font-medium mb-4" data-id="element-173">
                {member.role}
              </p>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-174">
                {member.bio}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}